module.exports = __webpack_public_path__ + "img/facebook.6252bf27.svg";